import React from 'react';
import { CancelToken } from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import makeRequest from '../../utils/makeRequest';
import {
  getMediwireApiUrl,
  createGA,
  getAppPlatform,
  timedoutVal,
  getSlotNumber,
  getSecId,
  getGeoInfo,
} from './config';
import { reciveHomePageData } from '../../routes/home/layouts/India/redux';
import Card from '../../components_v2/common/CardV2/Card';
import Loader from '../../components/Loader';

/**
 * Component that fetches story from Mediawire and show it
 */
class WithMediawireStories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: null,
      loading: false,
    };
    this.timeout = null;
  }

  componentDidMount() {
    if (window || typeof window.geoinfo !== 'undefined') {
      this.getStory();
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  /**
   * Set story based on mediaiwire api
   * @param {*} Object consisting of fallback flag which indicates if mediawire story to show and story
   */
  setItem = ({ fallback, item }) => {
    const { fallbackItem, isWapView } = this.props;
    if (fallback === true) {
      this.setState({ item: fallbackItem, loading: false });
    } else if (!fallback) {
      if (isWapView === false) {
        this.swapTopStoryWithMediawire(item);
      }
      this.setState({ item, loading: false });
    }
    if (
      this.props.renderCallback &&
      typeof this.props.renderCallback === 'function'
    ) {
      this.props.renderCallback();
    }
  };

  /**
   * Swaps replacable story from column1 with last storyt of column3
   */
  swapTopStoryWithMediawire = mediawireStory => {
    const { fallbackItem, setListItems, listItems, index } = this.props;
    const topStoryListItems = [];
    let itemAdded = false;
    listItems.forEach(item => {
      let subItems = [];
      if (item.tn === 'column_2_list' && !itemAdded) {
        itemAdded = true;
        subItems = [
          ...item.items.slice(0, item.items.length - 1),
          {
            ...fallbackItem,
            replace_with_mediawire: null,
          },
        ];
      }

      if (item.tn !== 'lead_plus_4_list' && !itemAdded) {
        itemAdded = true;
        subItems = [...item.items];
        if (subItems[index]) {
          subItems[index] = {
            ...mediawireStory,
            replace_with_mediawire: null,
          };
        }
      } else {
        subItems = [...item.items];
      }
      topStoryListItems.push({
        ...item,
        items: subItems,
      });
    });
    setListItems(topStoryListItems);
  };

  /**
   * Handles exceptions in the data provided by geoapi.indiatimes.com to sync it with data in mediawire's database.
   * Exceptions Handled:
   * 1. Vishakhapatnam => Visakhapatnam
   * 2. Manesar, OR => Manesar, HR
   */
  syncGeoInfoWithMediawire = geodata => {
    if (
      geodata &&
      geodata.city &&
      typeof geodata.city === 'string' &&
      geodata.city.toLowerCase() === 'vishakhapatnam'
    ) {
      geodata.city = 'VISAKHAPATNAM';
      return geodata;
    }
    if (
      geodata &&
      geodata.city &&
      typeof geodata.city === 'string' &&
      geodata.city.toLowerCase() === 'manesar'
    ) {
      geodata.region_code = 'HR';
      return geodata;
    }
    return geodata;
  };

  /**
   * Fetches story using Mediawire api
   */
  getStory = () => {
    const { isWapView, slotId } = this.props;
    const source = CancelToken.source();
    const geoinfo = this.syncGeoInfoWithMediawire(getGeoInfo());

    const payload = {
      ...geoinfo,
      appPlatform: getAppPlatform(isWapView),
      sltno: slotId || getSlotNumber(isWapView),
      secid: getSecId(isWapView),
    };

    // Adding timeout functionality
    this.timeout = setTimeout(() => {
      source.cancel();
      if (this.state.item === null) {
        this.setItem({ fallback: true });
      }
    }, timedoutVal);

    this.setState({ loading: true });

    makeRequest
      .get(getMediwireApiUrl(payload), { cancelToken: source.token })
      .then(data => {
        if (
          data &&
          data.status === 200 &&
          Array.isArray(data.data) &&
          data.data[0]
        ) {
          if (data.data[0].news && data.data[0].news.id) {
            this.setItem({ item: data.data[0].news, fallback: false });
          } else {
            this.setItem({ fallback: true });
          }
        } else {
          this.setItem({ fallback: true });
        }
      })
      .catch(err => {
        this.setItem({ fallback: true });
        console.error(err);
      });
  };

  getKey = () => {
    const { isWapView } = this.props;
    const { item } = this.state;
    if (isWapView === true) {
      return `card_${item.wu || item.sltno}`;
    } else if (isWapView === false) {
      return item.id;
    }
    return '';
  };

  /**
   * Returns props as per mobile and desktop
   */
  getProps = () => {
    const { isWapView, imgWidth, isInlineSmallIconCard, index } = this.props;
    const { item } = this.state;
    const _key = this.getKey();
    const spotlightGA =
      item.ag && item.ag === 'spotlight' ? `sl_${index + 1}_${item.id}` : null;
    let _props = {
      imgWidth,
      data: item,
      isInlineSmallIconCard,
      index,
      isWapView,
      key: _key,
      viewga: spotlightGA,
    };
    if (isWapView === true) {
      const { isLead, gaAction } = this.props;
      _props = {
        ..._props,
        isLeadImageNews: isLead,
        doNotChangeURL: item.dnc === '1' || false,
        // itemClass: index >= 0 && s.leadspacing,
        linkData: {
          gaAction,
          gaLabel: `ArticleClick/${index}/${item.wu}`,
        },
        target: item.target === '1',
        isHalfMobileTile: false,
      };
    } else if (isWapView === false) {
      const ga = createGA({ item, index, isWapView });
      _props = {
        ..._props,
        newga: ga,
      };
    }
    return _props;
  };

  render() {
    const { item, loading } = this.state;
    const { isWapView } = this.props;
    const { index } = this.props;
    if (
      typeof window === 'undefined' ||
      !item ||
      typeof window.geoinfo === 'undefined'
    ) {
      return isWapView === true ? null : <Loader />;
    }

    if (loading && isWapView === false) {
      return <Loader />;
    } else if (loading && isWapView === true) {
      return null;
    }
    if (typeof this.props.renderFunc === 'function') {
      return this.props.renderFunc(item, index);
    }
    return <Card {...this.getProps()} />;
  }
}

const mapStateToProps = state => ({
  homepagedata: state.homepage.data,
});

const mapDispatchToProps = dispatch => ({
  setHomepageData: params => {
    dispatch(reciveHomePageData(params));
  },
});

WithMediawireStories.propTypes = {
  index: PropTypes.number.isRequired,
  isWapView: PropTypes.bool,
  isInlineSmallIconCard: PropTypes.bool,
  isLead: PropTypes.bool,
  fallbackItem: PropTypes.shape({}),
  gaAction: PropTypes.shape({}),
  setHomepageData: PropTypes.func.isRequired,
  imgWidth: PropTypes.string,
  homepagedata: PropTypes.shape({}).isRequired,
  renderCallback: PropTypes.func.isRequired,
  slotId: PropTypes.string,
};

WithMediawireStories.defaultProps = {
  imgWidth: '100',
  isWapView: false,
  isLead: null,
  gaAction: null,
  fallbackItem: null,
  isInlineSmallIconCard: true,
  slotId: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(
  WithMediawireStories,
);
